import CryptoJS from 'crypto-js'

function getKeyWordArray () {
  const key = (window.__gconf && window.__gconf.aesKey ? window.__gconf.aesKey : '').toString()
  const k = key || 'default_key'
  return CryptoJS.MD5(k).concat(CryptoJS.MD5(k + '1'))
}

export function encryptObj (obj) {
  const iv = CryptoJS.lib.WordArray.random(16)
  const key = getKeyWordArray()
  const plain = JSON.stringify(obj || {})
  const encrypted = CryptoJS.AES.encrypt(plain, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return {
    enc: 1,
    alg: 'AES-256-CBC',
    iv: CryptoJS.enc.Base64.stringify(iv),
    data: encrypted.ciphertext.toString(CryptoJS.enc.Base64)
  }
}

export function decryptObj (payload) {
  if (!payload || parseInt(payload.enc) !== 1) return null
  const key = getKeyWordArray()
  const iv = CryptoJS.enc.Base64.parse(payload.iv || '')
  const ciphertext = CryptoJS.enc.Base64.parse(payload.data || '')
  const decrypted = CryptoJS.AES.decrypt({
    ciphertext: ciphertext
  }, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  const plain = decrypted.toString(CryptoJS.enc.Utf8)
  if (!plain) return null
  try {
    return JSON.parse(plain)
  } catch (e) {
    return null
  }
}
